import React from 'react'
import styled from 'styled-components'
import { InfoIcon } from '@primer/octicons-react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

const Separator = styled.span`
  position: relative;
  top: -4px;
  display: inline-block;
  margin-left: 6px;
  margin-right: 6px;
  color: black;
`

const BasicInfo = ({ edad, sexo }) => {
  return (
    <p className="pb-0 mb-2 leading-none">
      {edad && (
        <span>
          <strong>{edad}</strong> años
        </span>
      )}
      {edad && sexo && <Separator>.</Separator>}
      {sexo && (
        <>
          <strong>{sexo}</strong>
          <Tippy
            content={
              <p>
                <InfoIcon className="w-4 h-4 pb-0 ml-1 text-gray-500" /> El sexo
                es importante porque determina los cupos según la paridad de
                género.{' '}
              </p>
            }>
            <button className="" aria-label="Información sobre sexo">
              <InfoIcon className="w-4 h-4 ml-1 text-gray-500" />
            </button>
          </Tippy>
        </>
      )}
    </p>
  )
}

export default BasicInfo
